import { ITask, TaskState } from '@modules/TasksModule/types';
import { InboxContext } from '../types';
import { inboxState } from '../state';
import SoftPhoneModule from '@modules/SoftPhoneModule';

import { setExternalCallToRejected } from '../callHandlers/externalCalls';

import { setInternalCallToRejected } from '../callHandlers/internalCalls';

function handleTaskReject(_context: InboxContext, task: ITask): void {
  inboxState.selectedTaskId = undefined;

  if (task.isInternal) {
    setInternalCallToRejected(_context, task.id);
    SoftPhoneModule.endCall(task.id);
  } else if (task.state === TaskState.Offered) {
    setExternalCallToRejected(_context, task.id, _context.userId);
    SoftPhoneModule.callControl.cancel();
  }
}

export default handleTaskReject;
